import { render, staticRenderFns } from "./companyNormal.vue?vue&type=template&id=8405d1d4&"
import script from "./companyNormal.vue?vue&type=script&lang=js&"
export * from "./companyNormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports